"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NUMBER_OF_PROPERTIES_TO_RETURN = exports.ADVISOR_ESTIMATED_DAYS_BETWEEN_CORE_LOGIC_SNAPSHOT_UPDATES = exports.ADVISOR_MIN_DAYS_BETWEEN_CORE_LOGIC_TRANSACTION_HISTORY_PULLS = exports.ADVISOR_MIN_DAYS_BETWEEN_CORE_LOGIC_PULLS = exports.ADVISOR_MIN_DAYS_BETWEEN_HOUSE_CANARY_PULLS = void 0;
exports.ADVISOR_MIN_DAYS_BETWEEN_HOUSE_CANARY_PULLS = 30;
exports.ADVISOR_MIN_DAYS_BETWEEN_CORE_LOGIC_PULLS = 90;
exports.ADVISOR_MIN_DAYS_BETWEEN_CORE_LOGIC_TRANSACTION_HISTORY_PULLS = 180; // It is unlikely that an Advisor Lead will have new tranasactions within a short period of time
exports.ADVISOR_ESTIMATED_DAYS_BETWEEN_CORE_LOGIC_SNAPSHOT_UPDATES = 30;
exports.MAX_NUMBER_OF_PROPERTIES_TO_RETURN = 6;
